import React ,{ useEffect, useRef } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { IFilterSociete, getDefaultFilterSociete } from "../../../models/interfaces/IFilterSociete";
import { validationMode } from "../../../config/helpers";
import CpntFilterButtons from "../../../components/CpntFilterButtons";

interface IProps {
  filter?: IFilterSociete;
  changeFilter: (data: IFilterSociete) => void;
}


//Arrive pas a faire passer unb param au parent...
const SocietesFilter: React.FC<IProps> = ({ filter, changeFilter }) => {

  const prevFilterRef = useRef<IFilterSociete | undefined>(filter);

  useEffect(() => {

    // if (getValues("Societe") !== filter?.Societe) {
    //   setValue("Societe",filter?.Societe);
    // }

    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }

    prevFilterRef.current = filter;
  }, [filter]);

  
  const formMethods = useForm<IFilterSociete>({
    defaultValues: getDefaultFilterSociete(),
  });

  const { handleSubmit, reset, getValues } = formMethods;

  const handleResetForm = () => {
    localStorage.removeItem("IFiltersocietes");
    changeFilter(getDefaultFilterSociete());
    reset(getDefaultFilterSociete()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data: IFilterSociete) => {
    changeFilter(data);
    localStorage.setItem("IFiltersocietes",JSON.stringify(data)); //needed ??
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      //SubmitButton.current.click();
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6, 12]}>
            <TextInput
              label="Societe"
              formName="Societe"
              validationStyle={validationMode.none}
              placeholder="Societe"
            />
            <div></div>
            <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default SocietesFilter;
